export const HELP_GUIDE_URL = 'https://caraplug.com/help';
